import {
  type ApiResponse,
  HTTPMethod,
  unauthenticatedRequest,
} from '../../../global/api'
import { type TokenResult } from '../../../authService/types'

type PreviewParams = {
  videoId: number
  videoToken: string
}

type PhotoDomainDTO = {
  site_id?: number
  domain?: string
  url?: string
}

const parsePreviewParams = (pathname: string): PreviewParams | null => {
  const match = pathname.match(/\/personal\/(\d+)\/([a-f0-9A-F]{20,})/)
  if (!match) return null

  return {
    videoId: parseInt(match[1], 10),
    videoToken: match[2],
  }
}

const fetchPublicPreviewSiteUrl = async ({
  origin,
  videoId,
  videoToken,
}: PreviewParams & { origin: string }) => {
  const response = await unauthenticatedRequest<ApiResponse<PhotoDomainDTO>>(
    origin,
    {
      url: '/api/2/photo/domain',
      method: HTTPMethod.GET,
      data: {
        photo_id: videoId,
        token: videoToken,
      },
    }
  )

  const { data } = response

  return data.url
}

const createPreviewTokenStub = (siteUrl: string): TokenResult => {
  return {
    bearer_token: '',
    expiration_time: '',
    site_name: 'personal',
    site_url: siteUrl,
    site_id: 0,
    domain: '',
    internal_site_name: '',
    trunc_site_name: '',
    product_key: 'personal',
    product_name: '',
    site_key: 'personal',
    api_base_url: siteUrl,
    logo_url: '',
    icon_url: '',
    entry_url: '',
    capabilities: '',
    display_name: '',
    subscription_id: 0,
  }
}

interface BootstrapOptions {
  pathname: string
  origin: string
  setQueryData: (key: string, value: TokenResult[]) => void
  renderPreview: (params: {
    videoId: number
    videoToken: string
    siteUrl: string
  }) => void
}

const bootstrapPersonalVideoPreview = async ({
  pathname,
  origin,
  setQueryData,
  renderPreview,
}: BootstrapOptions) => {
  const params = parsePreviewParams(pathname)
  if (!params) return

  const siteUrl = await fetchPublicPreviewSiteUrl({
    origin,
    videoId: params.videoId,
    videoToken: params.videoToken,
  }).catch(() => null)

  if (!siteUrl) return
  setQueryData('tokens', [createPreviewTokenStub(siteUrl)])
  renderPreview({
    videoId: params.videoId,
    videoToken: params.videoToken,
    siteUrl,
  })
}

export { bootstrapPersonalVideoPreview }
